import * as React from "react";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

export default class EVisitNeedsAccount extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { userData, userTags } = this.props;
        logUI('MBHWeb.Evisits.Start.General.NeedsAccount', new Date(), Tools.getURLPath(), userData, 'eVisits', 'General' + userTags());
    }

    render() {
        const { registrationUrl, technicalHelpDeskNumber, technicalHelpDeskHours } = this.props;
        return (
            <div id="evisit-action" className="row">
                <div className="col-12">
                    <label id="lblEVisitMessage">
                        Adult patients must take an eVisit or screening from their own MyBSWHealth account.{' '}
                        If you do not have one you can create one <Link to={{ pathname: registrationUrl }} target="_blank">here</Link>.<br /><br />
                        For technical assistance, call the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                    </label>
                </div>
            </div>
        );
    }
}